import React from 'react';

import { Box } from '@simplybusiness/mobius-simplybusiness';
import { Text } from '@simplybusiness/mobius-core';
import { tick } from '@simplybusiness/icons';

import CircleIcon from '../atoms/CircleIcon';

const ErnCapturedConfirmation = () => (
  <Box style={{ textAlign: 'center', width: '100%' }}>
    <CircleIcon icon={tick} variant="green" />
    <Text
      component="h1"
      marginTop="size-60"
      fontSize={31}
      fontWeight={700}
    >
      Thanks for letting us know
    </Text>
  </Box>
);

export default ErnCapturedConfirmation;
